import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "patient-retention-card card mb-4 border-0 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }
const _hoisted_4 = { class: "dropdown action-opt" }
const _hoisted_5 = { class: "dropdown-menu dropdown-menu-end bg-white border box-shadow" }
const _hoisted_6 = { class: "trezo-card-content" }
const _hoisted_7 = { class: "chart" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("h5", { class: "mb-0" }, "Patient Retention", -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("button", {
            class: "btn bg-transparent p-0",
            type: "button",
            "data-bs-toggle": "dropdown",
            "aria-expanded": "false"
          }, [
            _createElementVNode("i", { class: "ri-more-2-fill" })
          ], -1)),
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "dropdown-item",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateTimeframe('This Day')))
              }, " This Day ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "dropdown-item",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateTimeframe('This Week')))
              }, " This Week ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "dropdown-item",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateTimeframe('This Month')))
              }, " This Month ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "dropdown-item",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateTimeframe('This Year')))
              }, " This Year ")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_ctx.isClient)
            ? (_openBlock(), _createBlock(_component_apexchart, {
                key: 0,
                type: "line",
                height: "330",
                options: _ctx.chartOptions,
                series: _ctx.series
              }, null, 8, ["options", "series"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}